// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3_96c","title":"Images45_title__1vNZC","images":"Images45_images__3Y05b"};